import BipoleChartBody from "./BipoleChartBody";

export default BipoleChartBody